import { useTranslation } from "react-i18next";
import { Drawer } from "antd";




import { useFlowNodes } from "../../context";
import { addNode, addNodeTitle } from "../utils/addNode";
import { nodesExist } from "../utils/hasNodes";

import "./Sidebar.scss";
import { useSidebar } from "../SidebarFlow/context";
import { useSidebarActions } from "../SidebarFlow/hook/actionButtons";
import { renderDefaultOptions, renderEntradasOptions, renderExtensionsOptions, renderIntegrationsOptions, renderParameterOptions, renderRespuestasOptions } from "../SidebarFlow/components";

const SidebarFlow = () => {
  const { t } = useTranslation();
  const { sidebar, closeSidebar } = useSidebar();

  const {
    setNodes,
    setEdges,
    nodes,
    variables,
    intent,
    updateVariables,
    updateIntent,
  } = useFlowNodes();

  const handleAdd = (type, isDefault, dataInfo) => {
    const data = {
      setNodes,
      setEdges,
      dataNode: sidebar.dataNode,
      type,
      dataInfo,
    };
    if (isDefault) {
      addNodeTitle({
        nodesExist: nodesExist({
          nodes,
          parentId: sidebar?.dataNode?.data.parentData.id,
        }),
        ...(data || {}),
      });
      closeSidebar();
      return;
    }
    addNode({
      nodesExist: nodesExist({
        nodes,
        parentId: sidebar?.dataNode?.data.parentData.id,
      }),
      ...(data || {}),
    });
    closeSidebar();
  };

  const actionButtons = useSidebarActions(t, nodes);
  const renderOptions = {
    parameterIntentNode: renderParameterOptions(handleAdd, t),
    integrationIntentNode: renderIntegrationsOptions(handleAdd, t, nodes),
    extensionIntentNode: renderExtensionsOptions(handleAdd, t, nodes, {
      variables,
      intent,
      updateVariables,
      updateIntent,
    }),
    entryIntentNode: renderEntradasOptions(handleAdd, t, nodes),
    responseIntentNode: renderRespuestasOptions(handleAdd, t, nodes),
  };
  return (
    <Drawer
      open={sidebar.open}
      onClose={closeSidebar}
      placement="right"
      className="sidebar-container"
      width={360}
      style={{
        padding: "0px",
      }}
    >
      <span className="sidebar-title">
        {t("common:intents.flow_chat.title")}
      </span>
      <p className="sidebar-subtitle">
        {t("common:intents.flow_chat.message")}
      </p>

      {renderOptions[sidebar.dataNode?.data.parentData.principalParentType] ||
        renderDefaultOptions(handleAdd, actionButtons)}
    </Drawer>
  );
};

export default SidebarFlow;
